<template>
    <Paper class="barcode-merge">
        <m-table
            ref="RegistrationTable"
            :pageTotal="pageTotal"
            :tableData="listData"
            :config="tableConfig"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @search="search"
            @onSearchDataChange="onSearchDataChange"
            @btn-event="goDetail">
            <template v-slot:page-module-btn>
                <div class="btnList">
                    <el-button size="mini" type="primary" icon="el-icon-plus" @click="addData">新增</el-button>
                </div>
            </template>
        </m-table>
        <m-dialog class="dialog" ref="mFrom" :config="fromConfig" :keepComponent="false" @submit="submit" @close="close" @onFromDataChange="onFromDataChange">
          <m-table
            slot="mTable"
            ref="formTable"
            :pageTotal="stepTotal"
            :tableData="nodeData"
            :config="nodeConfig"
             @onSelectionChange="onSelectionChange">
            <template v-slot:column-nodeSequence="{props}">
                <div @click.stop="()=>{}">
                    <el-input-number
                        class="input"
                        :controls="false"
                        :max="99"
                        :min="1"
                        v-model="props.row.nodeSequence"
                        @blur="inputChange(props)">
                    </el-input-number>
                </div>
             </template>
             <div slot="able-module-btn-right" class="btn-box">
                <el-button size="default" icon="el-icon-delete" :disabled="!this.stepDtoList.length" @click="deleteStepData">删除</el-button>
                <el-button type="primary" icon="el-icon-plus" size="default" @click="addStepSave" >添加</el-button>
            </div>
        </m-table>
        </m-dialog>
        <node-save ref="nodeSave" @nodeSubmit="nodeSubmit"></node-save>
         <el-dialog
            :visible.sync="listDialogVisible"
            width='50%'
            title="全场景"
         ><el-tree :data="dialogData" :props="defaultProps" default-expand-all></el-tree></el-dialog>
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import { getSceneList, addSceneSave, updateSceneSave, editSceneDetail, editSceneAll } from '../../../api/systemManagementApi';
import { dictWithUrl } from '../../../components/basicDataDialog/api.js';
import { tableConfig } from './tableConfig.js';
import { cloneDeep } from 'lodash';
import mDialog from '@/modules/sn/components/formRequired/mDialog';
import { nodeConfig } from './nodeConfig.js';
import { fromConfig } from './fromConfig';
import { mapGetters } from 'vuex';
import nodeSave from './nodeSave';
// eslint-disable-next-line no-unused-vars
const disabledKye = ['scanSys', 'operateType', 'invokeMethod'];
export default {
    name: 'node',
    components: { Paper, mTable, mDialog, nodeSave },
    data() {
        return {
            fromConfig,
            nodeConfig,
            nodeData: [],
            stepDtoList: [],
            pageTotal: 0, // 总条数
            listData: [], // 列表数据
            searchData: {}, // 搜索框数据
            tableConfig, // 表格配置
            stateDictList: {}, // 可用状态字典
            detailList: {},
            listDialogVisible: false,
            dialogData: [],
            defaultProps: {
                children: 'childList',
                label: 'name'
            },
            sceneCode: '', // 存储点击修改的nodeCode
            fromData: {},
            rulesFrom: {
                scanSys: [
                    { validator: this.validatorSourceSys, message: '请选择扫码系统', trigger: 'change' }
                ],
                operateType: [
                    { validator: this.validatorSourceSys, message: '请选择操作类型', trigger: 'change' }
                ],
                invokeMethod: [
                    { validator: this.validatorSourceSys, message: '请选择调用方式', trigger: 'change' }
                ],
                stepDtoList: [
                     { validator: this.validateSelected, message: '请添加步骤节点', trigger: 'change' }
                 ] }
        };
    },
    created() {
        this.search(this.searchData);
        this.dicDomain();
        Object.assign(this.fromConfig.fromComponent.rules, this.rulesFrom);
        this.tableConfig.table.rowSpanMethod = this.rowSpanMethod;
    },
    computed: {
        ...mapGetters(['currentTenant']),
        stepTotal() {
            return this.nodeData.length;
        }
    },
    watch: {
      'fromData.sourceSys': {
        handler(val) {
            this.fromConfig.fromComponent.component.forEach(item => {
            if (disabledKye.includes(item.prop)) {
                if (val && val.length > 0) {
                    item.useAttr.disabled = false;
                } else {
                    item.useAttr.disabled = true;
                }
            }
            });
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
        onSearchDataChange(data) {
            this.searchData = data;
        },
        onFromDataChange(val) {
            this.fromData = val;
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.search(this.searchData);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            this.search(this.searchData);
        },
        // 查询
        search(data) {
            this.getData(data);
        },
        getData(data) {
            const params = cloneDeep(data);
             Object.keys(params).forEach(item => {
                if (!params[item]) {
                    delete params[item];
                }
            });
            params.tenantCode = this.currentTenant.tenantCode;
            params.pageSize = this.tableConfig.page.pageSize;
            params.pageNo = this.tableConfig.page.pageNo;
            // this.listData = [];
            getSceneList(params).then((res) => {
                if (res.code + '' === '0' && res.data) {
                    this.pageTotal = res.data.totalCount;
                    this.listData = res.data.list;
                    this.listData.forEach(item => {
                        item.enableFlag = item.enableFlag === 'Y' ? '启用' : '禁用';
                    });
                }
            });
        },
        // 修改，请求明细数据回显
        goDetail(row, index, event) {
            this.sceneCode = row.sceneCode;
            const params = {
                sceneCode: row.sceneCode,
                tenantCode: this.currentTenant.tenantCode
            };
            switch (event) {
                case 'edit':
                    this.editNodeSave(params);
                    break;
                default:
                    this.lookNodeSave(params);
                    break;
            }
        },
        // 修改
        editNodeSave(params) {
            this.fromConfig.dialogAttr.title = '修改';
                this.fromConfig.fromComponent.component.unshift({
                    component: 'el-input',
                    span: 12,
                    prop: 'sceneCode',
                    name: '节点编码',
                    useAttr: {
                        placeholder: '节点编码',
                        disabled: true
                    }
                });

                this.nodeData = [];
                const arrayKey = ['sourceSys', 'scanSys'];
                editSceneDetail(params).then(async res => {
                    if (res.code + '' === '0' && res.data) {
                        this.detailList = res.data;
                        arrayKey.forEach(key => {
                            this.detailList[key] = this.detailList[key] ? this.detailList[key].split(',') : [];
                        });
                        this.nodeData = res.data.nodeDtoList;
                        this.$refs.mFrom.open(this.detailList);
                }
            });
        },
        // 查看
        lookNodeSave(params) {
            this.listDialogVisible = true;
            editSceneAll(params).then(res => {
                this.dialogData = [res.data];
            });
        },
        addData() {
            this.fromConfig.dialogAttr.title = '新增';
            this.nodeData = [];
            this.sceneCode = '';
            this.$refs.mFrom.open();
        },
        // 新增修改提交事件
        submit(val) {
             this.nodeData.forEach((item, index) => {
                item.nodeSequence = index + 1;
            });
            const params = {
                ...val,
                nodeDtoList: this.nodeData,
                sourceSys: val.sourceSys && val.sourceSys.length > 0 ? val.sourceSys.join(',') : '',
                scanSys: val.sourceSys && val.sourceSys.length > 0 ? val.scanSys.join(',') : ''
            };
            if (val.id) {
                // 修改
                updateSceneSave(params).then(res => {
                    if (res.code + '' === '0') {
                        this.search(this.searchData);
                        this.$refs.mFrom.hiedDialogVisible();
                        this.$message.success('修改成功');
                    }
                });
            } else {
                // 新增
                params.tenantCode = this.currentTenant.tenantCode;
                addSceneSave(params).then((res) => {
                    if (res.code + '' === '0') {
                        this.search(this.searchData);
                        this.$refs.mFrom.hiedDialogVisible();
                        this.$message.success('新增成功');
                    }
                });
            }
        },
        // 自定义校验
        validateSelected(rule, value, callback) {
            if (this.nodeData.length === 0) {
                callback(new Error('请添加步骤节点'));
            } else {
                callback();
            }
        },
        // 判断是否选中了来源系统，选中则扫码，操作，调用必填
        validatorSourceSys(rule, value, callback) {
             if (this.fromData.sourceSys && this.fromData.sourceSys.length > 0) {
                if (value && value.length > 0) {
                    callback();
                } else {
                    callback(new Error(''));
                }
            } else {
                callback();
            }
        },
        rowSpanMethod(item) {
            return this.customSpanMethod(item);
        },
        // 自定义合并行或列
        customSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 1 || columnIndex === 2) {
                // 如果是第2列（key 列），检查相邻的上一行是否有相同值
                if ((rowIndex > 0 && row.sceneCode === this.listData[rowIndex - 1].sceneCode) &&
                    (rowIndex > 0 && row.sceneName === this.listData[rowIndex - 1].sceneName)) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
                // 计算当前值在该列中横跨的行数
                let rowspan = 1;
                for (let i = rowIndex + 1; i < this.listData.length; i++) {
                    if (row.sceneCode === this.listData[i].sceneCode) {
                        rowspan++;
                    } else {
                        break;
                    }
                }
                return {
                    rowspan,
                    colspan: 1
                };
            }
        },
        onSelectionChange(data) {
            this.stepDtoList = data;
        },
        // 删除已添加步骤表
        deleteStepData() {
            this.nodeData = this.nodeData.filter(item => !this.stepDtoList.some(step => step.nodeCode === item.nodeCode));
        },
        // 添加步骤到已添加步骤表
        addStepSave() {
            this.$refs.nodeSave.open(this.sceneCode, this.nodeData);
        },
        nodeSubmit(data) {
            const dataList = data.filter(item => !this.nodeData.some(node => node.nodeCode === item.nodeCode));
            this.nodeData = this.nodeData.concat(dataList);
            this.nodeData.forEach((item, index) => {
                this.$set(item, 'nodeSequence', index + 1);
            });
        },
        inputChange(data) {
            if (!data.row.nodeSequence) data.row.nodeSequence = 1;
            this.nodeData.sort((a, b) => {
                return a.nodeSequence - b.nodeSequence;
            });
        },
        close() {
            this.fromConfig.fromComponent.component = this.fromConfig.fromComponent.component.filter(item => item.prop !== 'sceneCode');
        },
        async dicDomain() {
         const options = await dictWithUrl('DOMAIN_SOURCE_SYS,SCAN_SYS,OPERATE_TYPE,INVOKE_METHOD');
         if (options.code + '' === '0') {
             this.fromConfig.fromComponent.component.forEach(item => {
             if (item.prop === 'sourceSys') {
                item.options = this.dicEnable(options.data, 'DOMAIN_SOURCE_SYS');
             }
             if (item.prop === 'operateType') {
                item.options = this.dicEnable(options.data, 'OPERATE_TYPE');
             }
             if (item.prop === 'invokeMethod') {
                item.options = this.dicEnable(options.data, 'INVOKE_METHOD');
             }
             if (item.prop === 'scanSys') {
                item.options = this.dicEnable(options.data, 'SCAN_SYS');
             }
         });
         }
        },
        dicEnable(options, key) {
            if (options[key]) {
                return options[key].map(item => {
                    return {
                        label: item.name,
                        value: item.code
                    };
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge {
    /deep/ .el-table {
        height: calc(100vh - 200px) !important;
    }
    .dialog{
    /deep/ .nPanel-1{
        width: 100% !important;
        .el-table {
        height: 300px !important;
        }
    }
    /deep/ .el-dialog{
        margin-top: 8vh !important;
    }
    }
}
.btn-box{
    margin-bottom: 10px;
}
.input{
    width: 90%;
}

</style>
